import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min"; // Added for Bootstrap JS
import React from "react";
import ReactDOM from "react-dom/client"; // Updated for React 18
import App from "./App";
import "./index.css";

// ReactDOM rendering for React 18
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
